// extracted by mini-css-extract-plugin
module.exports = {"categories":"CategoryView_categories__4g_75","popularBrands":"CategoryView_popularBrands__T8YHI"};